<template>
  <div class="test-analytics">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div class="text-center p-4">
            <feather-icon icon="BarChartIcon" size="48" class="text-muted mb-3"/>
            <h5 class="text-muted">Test Analytics Dashboard</h5>
            <p class="text-muted">Advanced analytics and reporting features coming soon!</p>
            <b-button variant="primary" @click="$emit('refresh')">
              <feather-icon icon="RefreshCwIcon" size="16" class="mr-1"/>
              Refresh Data
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BButton } from 'bootstrap-vue'

export default {
  name: 'TestAnalytics',
  components: {
    BRow,
    BCol,
    BCard,
    BButton
  },
  props: {
    analytics: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
.test-analytics {
  .card {
    border: none;
    box-shadow: 0 4px 25px 0 rgba(0,0,0,0.1);
  }
}
</style>